import axios from "axios";
import {  message } from "ant-design-vue";
import store from "@/store";
import router from "@/router";
const service = axios.create({
//baseURL: "https://www.aowok.comFutureApi",
   baseURL: store.state.api+"/FutureApi/",
  timeout: 45000,
});

//定义请求拦截器
service.interceptors.request.use(
  (config) => {
    if (window.localStorage.Token&&window.localStorage.Token.length>=128) {
      config.headers["Authorization"] = "Bearer " + store.state.token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
    message.error("请求超时");
  }
);

//响应拦截器
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status == 401||error.response.status == 404) {
      // message.success("账号已过期，请重新登录！");
      window.localStorage.clear();
      }
    }
    return Promise.reject(error);
  }
);

export default service;
